import { render } from "./recentArrive.vue?vue&type=template&id=f468fcfa&scoped=true"
import script from "./recentArrive.vue?vue&type=script&lang=js"
export * from "./recentArrive.vue?vue&type=script&lang=js"

import "./recentArrive.vue?vue&type=style&index=0&id=f468fcfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f468fcfa"]])

export default __exports__